/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIConfirmModal from 'UIComponents/dialog/UIConfirmModal';
import UICheckbox from 'UIComponents/input/UICheckbox';
import { isSucceeded } from 'conversations-async-data/async-data/operators/statusComparators';
import { getData } from 'conversations-async-data/async-data/operators/getters';
import { getToggledAwayMode } from 'conversations-inbox-lib/usage-tracking/inboxInteractionEvents';
import { clickedConfirmOnAgentStatusPrompt, clickedCancelOnAgentStatusPrompt } from 'routing-ui/agent-status/utils/event-handlers';
import { useAgentStatus } from 'routing-ui/agent-status/hooks/useAgentStatus';
import { setDismissAgentStatusModalSessionStorage } from '../operators/statusModalOperators';
import { trackEvent } from '../../usage-tracking/clients/usageTracker';
import { usePromptDismissal } from '../../contextual-prompts/hooks/usePromptDismissals';
import { UserPromptType } from '../../contextual-prompts/constants/userPromptTypes';
import { getDismissedAt } from '../../contextual-prompts/operators/userPromptDataGetters';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const useComponent = closeModal => {
  const {
    toggleAwayMode: updateAwayMode
  } = useAgentStatus();
  const [doNotShowChecked, setDoNotShowChecked] = useState(false);
  const handleDoNotShowCheckbox = ({
    target: {
      checked
    }
  }) => {
    setDoNotShowChecked(checked);
  };
  const {
    asyncPromptData: asyncAgentStatusData,
    dismissPrompt: dismissAgentStatus
  } = usePromptDismissal(UserPromptType.SET_AVAILABILITY);
  const shouldHideModal = !isSucceeded(asyncAgentStatusData) || getDismissedAt(getData(asyncAgentStatusData)) > 0;
  if (shouldHideModal) {
    return {
      shouldHideModal,
      doNotShowChecked,
      handleDoNotShowCheckbox,
      onConfirm: null,
      onReject: null
    };
  }
  const onConfirm = () => {
    const nextAwayModeState = false;
    updateAwayMode(nextAwayModeState);
    if (doNotShowChecked) dismissAgentStatus();
    closeModal();
    trackEvent(clickedConfirmOnAgentStatusPrompt());
    trackEvent(getToggledAwayMode({
      awayMode: nextAwayModeState
    }));
  };
  const onReject = () => {
    if (doNotShowChecked) dismissAgentStatus();
    setDismissAgentStatusModalSessionStorage();
    trackEvent(clickedCancelOnAgentStatusPrompt());
    closeModal();
  };
  return {
    shouldHideModal,
    doNotShowChecked,
    handleDoNotShowCheckbox,
    onConfirm,
    onReject
  };
};
const SetAgentStatusPrompt = ({
  closeModal
}) => {
  const {
    shouldHideModal,
    doNotShowChecked,
    handleDoNotShowCheckbox,
    onConfirm,
    onReject
  } = SetAgentStatusPrompt.useComponent(closeModal);
  if (shouldHideModal) {
    return null;
  }
  return /*#__PURE__*/_jsx(UIConfirmModal, {
    "data-test-id": "selenium-agent-status-confirm-modal",
    width: 400,
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-inbox-ui.agentStatus.toggleAwayModalPrompt.title"
    }),
    description: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'conversations-inbox-ui.agentStatus.toggleAwayModalPrompt.descriptionWithEmailAndFormAvail'
        })
      }), /*#__PURE__*/_jsx(UICheckbox, {
        checked: doNotShowChecked,
        onChange: handleDoNotShowCheckbox,
        alignment: "center",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-inbox-ui.agentStatus.toggleAwayModalPrompt.doNotShow"
        })
      })]
    }),
    confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-inbox-ui.agentStatus.toggleAwayModalPrompt.confirm"
    }),
    rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-inbox-ui.agentStatus.toggleAwayModalPrompt.cancel"
    }),
    onConfirm: onConfirm,
    onReject: onReject
  });
};
SetAgentStatusPrompt.displayName = 'SetAgentStatusPrompt';
SetAgentStatusPrompt.useComponent = useComponent;
export default SetAgentStatusPrompt;